import tailwindColors from "tailwind.config/colors";

export const COLOR_OK = tailwindColors.green.DEFAULT;
export const COLOR_STARTED = tailwindColors.primary["600"];
export const COLOR_PAUSED = tailwindColors.orange.DEFAULT;
export const COLOR_ERROR = tailwindColors.red.DEFAULT;
export const COLOR_GRAY = tailwindColors.lightGray.DEFAULT;
